import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import AssignmentPopupTemporary from './AssignmentPopupTemporary'
import '../assets/css/components/single-profile-quest-overview.css'

class SingleProfileQuestOverview extends React.Component {
  constructor(props) {
    super(props)
    this.state = { quest: {} }
  }

  allProgress = ()=> {
    const { assignments, questAttempts, profile, profileId } = this.props
    const attemptList = _.map(questAttempts, (attempt,uuid)=>attempt) || []
    const assignmentList = _.map(assignments, (assignment,uuid)=>assignment) || []
    return attemptList.concat(assignmentList).filter(progress => (progress.profile_uuid === profileId) || (progress.student_profile_uuid === profileId))
  }

  getContentName = (progress)=> {
    if(_.isEmpty(progress.quest)) {
      switch (progress.edu_module_id) {
        case 1:
          return "Ecology Sandbox (The H.E.L.O.)"
          break;
        case 2:
          return "Growth & Genetics Sandbox (The Drakonarium)"
          break;
        case 6:
          return "Weather & Climate Sandbox (The O.R.B.)"
          break;
        default:
          return "Sandbox Unlock"
          break;
      }
    } else {
      return progress.quest.name
    }
  }

  getContentModuleName = (progress)=> {
    if(_.isEmpty(progress.quest)) {
      switch (progress.edu_module_id) {
        case 1:
          return "Ecology"
          break;
        case 2:
          return "Growth & Genetics"
          break;
        case 6:
          return "Weather & Climate"
          break;
        default:
          return "General Module"
          break;
      }
    } else {
      return progress.quest.module.name
    }
  }

  formatDate = date => date ? moment(date).format('MM/DD/YY') : null

  getStartedQuests = ()=> _.compact(this.allProgress().filter(progress => (progress.started_at && !progress.completed_at) ? progress : null))
  getCompletedQuests = ()=> _.compact(this.allProgress().filter(progress => progress.completed_at ? progress : null))

  render() {
    const { assignments, questAttempts, profile, profileId } = this.props
    return(
      <div className="quest-overview col-md-12 col-lg-6 m-b-10">
        <div className="ar-quests">
          <div id="completed-quest-list" className="widget-11-2 panel no-border panel-condensed no-margin widget-loader-circle">
            <div className="padding-25">
              <div className="pull-left">
                <h2 className="no-margin text-success">Quest Progress</h2>
                <p className="no-margin"><i>Select a quest to learn more.</i></p>
              </div>
              <h4 className="pull-right semi-bold text-info" style={{"marginTop": "3px"}}>
                { this.getStartedQuests().length } Started
                <br/>
                { this.getCompletedQuests().length } Completed
              </h4>
              <div className="clearfix"></div>
            </div>
            <div className="auto-overflow widget-11-2-table">
              {this.allProgress().length !== 0 &&
                <table className="table table-condensed table-hover">
                  <thead>
                    <tr>
                      {/*<th style={{'width':'12%'}}></th>*/}
                      <th>Quest</th>
                      <th>Module</th>
                      <th>Started At</th>
                      <th>Completed At</th>
                    </tr>
                  </thead>
                  <tbody>

                      {_.map(this.allProgress(), progress=>
                        <tr key={progress.to_be_assigned_at+this.getContentName(progress)} className="quest-row popup-trigger" onClick={()=>this.setState({ quest: progress.quest })}>
                          {/*<td><div className="quest-row-title font-montserrat all-caps fs-12 b-r b-dashed b-grey">{
                            progress.to_be_assigned_at ? <span title='This quest was assigned as part of a class' className="label font-montserrat fs-11">A</span> : ''}
                        </div></td>*/}
                          <td><div className="quest-row-title font-montserrat all-caps fs-12 b-r b-dashed b-grey">{this.getContentName(progress)}</div></td>
                          <td><div className="quest-row-title font-montserrat all-caps fs-12 b-r b-dashed b-grey">{this.getContentModuleName(progress)}</div></td>
                          <td><div className="quest-row-title font-montserrat all-caps fs-12 b-r b-dashed b-grey">{this.formatDate(progress.started_at) || '--'}</div></td>
                          <td><div className="quest-row-title font-montserrat all-caps fs-12 b-r b-dashed b-grey">{this.formatDate(progress.completed_at) || '--'}</div></td>
                        </tr>
                      )}

                  </tbody>
                </table>
              }
              {this.allProgress().length === 0 &&
                <div className='get-started'>
                  <i id="empty-quest-icon" className="fa fa-sign-in"></i>
                  <div className="hint-text" id="empty-quest-msg">
                    <h4>You haven't gotten started yet. Log into the game and do some quests!</h4>
                  </div>
                </div>
              }
              {!_.isEmpty(this.state.quest) && <AssignmentPopupTemporary assignableContent={this.state.quest} handleClose={()=>this.setState({ quest: {} })} resetForm={()=>{}} />}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default SingleProfileQuestOverview
